<custom-cursor class="fill pos-absolute-x pos-absolute-l pos-absolute-m pos-absolute-s">
    <ng-template #customCursorContent>
        @if (item().image) {
        <img [dfImage]="item().image"
             [priority]="priority()"
             [ratio]="item().ratio"
             [sizes]="item().sizes"
             [alt]="product()?.data?.name || ''"
             [photoswipe]="item().image"
             [photoswipeUid]="photoswipeUid()"
             [photoswipeOptions]="photoswipeOptions()"
             fill>
        }
        @if (item().video) {
        <!-- video -->
        <local-vimeo-player [video-url]="item().video"
                            [background]="true"
                            [autoplay-in-viewport]="true"
                            [loop]="true" />
        }
    </ng-template>
    <ng-template #customCursorIcon>
        <svg xmlns="http://www.w3.org/2000/svg"
             width="64"
             height="64"
             viewBox="0 0 16.933 16.933">
            <path d="M63.95 32A31.95 31.95 0 0132 63.95 31.95 31.95 0 01.05 32 31.95 31.95 0 0132 .05 31.95 31.95 0 0163.95 32z"
                  transform="scale(.26458 .26459)"
                  fill="#fff"
                  fill-opacity=".94"
                  stroke="#999"
                  stroke-width=".1" />
            <path d="M7.988 10.25V8.858H5.292v-.783h2.696V5.292h.87v2.783h2.784v.783H8.858v2.784h-.87z"
                  fill="#999" />
        </svg>
    </ng-template>
</custom-cursor>